/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { School } from '../../models/school';

export interface ApiSchoolItemIdGet$Params {
  item_id: number;
}

export function apiSchoolItemIdGet(http: HttpClient, rootUrl: string, params: ApiSchoolItemIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<School>> {
  const rb = new RequestBuilder(rootUrl, apiSchoolItemIdGet.PATH, 'get');
  if (params) {
    rb.path('item_id', params.item_id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<School>;
    })
  );
}

apiSchoolItemIdGet.PATH = '/api/school/{item_id}';
